import { render } from "./list-filter-sidebar.vue?vue&type=template&id=22bc43f8&ts=true"
import script from "./list-filter-sidebar.ts?vue&type=script&lang=ts"
export * from "./list-filter-sidebar.ts?vue&type=script&lang=ts"

import "./list-filter-sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__